/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentTransactionsListDocument: "shipment-transactions-list-document",
} as const;
